var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackFunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.137,
    height: 27.137,
    viewBox: "0 0 27.137 27.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.569) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.132,19.189a1.132,1.132,0,0,1-.8-1.933L17.256.331a1.132,1.132,0,1,1,1.6,1.6L1.933,18.857A1.128,1.128,0,0,1,1.132,19.189Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.954,2.264H1.132A1.132,1.132,0,0,1,1.132,0H14.954a1.132,1.132,0,0,1,0,2.264Z",
    transform: "translate(0 13.822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.132,16.087A1.132,1.132,0,0,1,0,14.954V1.132a1.132,1.132,0,1,1,2.264,0V14.954A1.132,1.132,0,0,1,1.132,16.087Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackFunction);
export default __webpack_public_path__ + "static/media/BackFunction.80a237cedef8e58e6e7f1deeb6a89817.svg";
export { ForwardRef as ReactComponent };